import {
    ChevronRight as EndIconOpenInPlannerBtn,
    SportsScore as IconEndTime,
    AccessTime as IconPlannedDuration,
    Person as IconRequiredFieldworkers,
    Start as IconStartTime,
    WbSunny as IconSunrise,
    WbTwilight as IconSunset,
} from "@mui/icons-material";
import { Link as RouterLink } from "react-router";

type Props = {
    visit: VisitInfoCardFragment;
    showOpenPlannerButton: boolean;
};

import { Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { dateForUrlFormatter, formatDate, formatSeconds, formatTime } from "~/modules/app/util/formatters";

import { VisitInfoCardFragment } from "./fragments.generated";
export function VisitInfoCardContent({ visit, showOpenPlannerButton }: Props) {
    const { t } = useTranslation("project");

    const startTime = visit.startTime ? parseStringToDate(visit.startTime) : undefined;
    const endTime = visit.endTime ? parseStringToDate(visit.endTime as string) : undefined;

    return (
        <Stack rowGap={2}>
            <Stack direction="row">
                <Stack direction="row" alignItems="center" columnGap={1} flex={1}>
                    <IconRequiredFieldworkers />
                    <Stack direction="column">
                        <Typography variant="caption">{t("projectReviewVisitV2.visitInfoCard.requiredWorkers")}</Typography>
                        <Typography>{visit.requiredFieldworkers}</Typography>
                    </Stack>
                </Stack>
                <Stack direction="row" alignItems="center" columnGap={1} flex={1}>
                    <IconPlannedDuration />
                    <Stack direction="column">
                        <Typography variant="caption">{t("projectReviewVisitV2.visitInfoCard.plannedDuration")}</Typography>
                        <Typography>{visit.duration ? formatSeconds(visit.duration) : "—"}</Typography>
                    </Stack>
                </Stack>
            </Stack>
            <Stack direction="row">
                <Stack direction="row" alignItems="center" columnGap={1} flex={1}>
                    <IconStartTime />
                    <Stack direction="column">
                        <Typography variant="caption">{t("projectReviewVisitV2.visitInfoCard.start")}</Typography>
                        {startTime ? (
                            <>
                                <Typography>{formatTime(startTime)}</Typography>
                                <Typography>{formatDate(startTime)}</Typography>
                            </>
                        ) : (
                            <Typography>—</Typography>
                        )}
                    </Stack>
                </Stack>
                <Stack direction="row" alignItems="center" columnGap={1} flex={1}>
                    <IconEndTime />
                    <Stack direction="column">
                        <Typography variant="caption">{t("projectReviewVisitV2.visitInfoCard.end")}</Typography>
                        {endTime ? (
                            <>
                                <Typography>{formatTime(endTime)}</Typography>
                                <Typography>{formatDate(endTime)}</Typography>
                            </>
                        ) : (
                            <Typography>—</Typography>
                        )}
                    </Stack>
                </Stack>
            </Stack>
            <Stack direction="row">
                <Stack direction="row" alignItems="center" columnGap={1} flex={1}>
                    <IconSunrise />
                    <Stack direction="column">
                        <Typography variant="caption">{t("projectReviewVisitV2.visitInfoCard.sunriseTime")}</Typography>
                        <Typography>
                            {visit.solarTime?.sunriseTime ? formatTime(parseStringToDate(visit.solarTime?.sunriseTime)) : "—"}
                        </Typography>
                    </Stack>
                </Stack>
                <Stack direction="row" alignItems="center" columnGap={1} flex={1}>
                    <IconSunset />
                    <Stack direction="column">
                        <Typography variant="caption">{t("projectReviewVisitV2.visitInfoCard.sunsetTime")}</Typography>
                        <Typography>
                            {visit.solarTime?.sunsetTime ? formatTime(parseStringToDate(visit.solarTime?.sunsetTime)) : "—"}
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>
            {startTime && showOpenPlannerButton && (
                <Button
                    variant="outlined"
                    endIcon={<EndIconOpenInPlannerBtn />}
                    sx={{ marginTop: 3 }}
                    component={RouterLink}
                    to={`/planner/${dateForUrlFormatter(startTime)}/areas/${visit.plannerAreaId}/visits/${visit.id}`}
                >
                    {t("projectReviewVisitV2.visitInfoCard.btnOpenPlanner")}
                </Button>
            )}
        </Stack>
    );
}
